import axios from "axios";

const state = {
  ingresos: { total: 0, cantidad: 0, movimientos: [] },
  gastos: { total: 0, cantidad: 0, movimientos: [] },
  flujo: {
    total_ingresos: 0,
    total_gastos: 0,
    utilidad: 0,
    cantidad: 0,
    movimientos: [],
  },
};

const mutations = {
  SET_INGRESOS(state, data) { state.ingresos = data; },
  SET_GASTOS(state, data) { state.gastos = data; },
  SET_FLUJO(state, data) { state.flujo = data; },
};

const actions = {
  async fetchIngresos({ commit }, params = {}) {
    const { data } = await axios.get("/api/reporte/ingresos", { params });
    commit("SET_INGRESOS", data);
    return data;
  },
  async fetchGastosReporte({ commit }, params = {}) {
    const { data } = await axios.get("/api/reporte/gastos", { params });
    commit("SET_GASTOS", data);
    return data;
  },
  async fetchFlujo({ commit }, params = {}) {
    const { data } = await axios.get("/api/reporte/flujo", { params });
    commit("SET_FLUJO", data);
    return data;
  },
};

const getters = {
  ingresos: (state) => state.ingresos,
  gastosReporte: (state) => state.gastos,
  flujo: (state) => state.flujo,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
